$(document).on('click', '.js-toggle-sidenav', function (event) {
    event.preventDefault();
    document.body.classList.toggle('sidenav-active');
    document.body.classList.toggle('noscroll');
    document.documentElement.classList.toggle('noscroll');
    $('.searchbar').removeClass('searchbar-active');
    $('.searchbar-toggler').toggleClass('searchbar-toggler-visible');
});
$(document).click(function (event) {
    if ($(event.target).closest('.sidenav').length === 0 && (!$(event.target).hasClass('js-toggle-sidenav') && $(event.target).closest('.js-toggle-sidenav').length === 0)) {
        $('.searchbar').removeClass('searchbar-active');
        $('.searchbar-toggler').removeClass('searchbar-toggler-visible');
        document.body.classList.remove('sidenav-active');
        document.body.classList.remove('noscroll');
        document.documentElement.classList.remove('noscroll');
    }
})
